import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { IButtonSelectOptions } from "@webapp/shared/components/button-select/button-select.models";

enum GoalPrivacyOptions {
  PRIVATE = "private",
  PUBLIC = "public",
}

type GoalPrivacy = "private" | "public";

const privacyOptions: IButtonSelectOptions[] = [
  {
    value: GoalPrivacyOptions.PRIVATE,
    label: GoalPrivacyOptions.PRIVATE,
    uiIconTheme: "outline",
    uiIconType: "restricted",
  },
  {
    value: GoalPrivacyOptions.PUBLIC,
    label: GoalPrivacyOptions.PUBLIC,
    uiIconTheme: "outline",
    uiIconType: "public",
  },
];

@Component({
  selector: "goal-privacy-button",
  templateUrl: "./goal-privacy-button.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoalPrivacyButtonComponent implements OnChanges {
  @Input() public model: boolean;
  @Input() public uiId: string;

  @Output() public readonly modelChange = new EventEmitter<boolean>();

  public privacyOptions: IButtonSelectOptions[] = privacyOptions;
  public selectedValue: GoalPrivacy;

  public ngOnChanges(changes: SimpleChanges): void {
    this.selectedValue = changes.model.currentValue === true ? GoalPrivacyOptions.PRIVATE : GoalPrivacyOptions.PUBLIC;
  }

  public handleChange(value: GoalPrivacy): void {
    this.modelChange.emit(value === GoalPrivacyOptions.PRIVATE);
  }
}
